import { Modal, Backdrop, Fade } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { createPortal } from "react-dom";

const useStyles = makeStyles(() => ({
    modal: {
        display: "flex",
        justifyContent: "center",
    },
    paper: {
        outline: "none",
    },
    bannerImage: {
        width: "375px",
        height: "auto",
        position: "absolute",
        transform: "translate(-50%, 350%)",
        "@media screen and (max-width: 450px)": {
            width: "100vw",
        },
    },
}));

export default function PopUp(props: { isModalOpen: boolean; setIsModalOpen: (param: boolean) => void }) {
    const classes = useStyles();

    const isModalOpen = props.isModalOpen;
    const setIsModalOpen = props.setIsModalOpen;

    const handleClose = () => {
        setIsModalOpen(false);
    };

    return createPortal(
        <Modal
            open={isModalOpen}
            onClose={handleClose}
            className={classes.modal}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
            disableAutoFocus={true}
            id="floating_modal"
        >
            <Fade in={isModalOpen}>
                <div className={classes.paper}>
                    <img
                        alt="complex"
                        className={classes.bannerImage}
                        src={`${process.env.PUBLIC_URL}/images/floating_top_202403.svg`}
                    />
                </div>
            </Fade>
        </Modal>,
        document.body,
    );
}
